import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation, } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  // eslint-disable-next-line
  selector: 'mm-expansion',
  templateUrl: './mm-expansion.component.html',
  styleUrls: ['./mm-expansion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('toggleExpand', [
      state('true', style({
        height: '*',
      })),
      state('false', style({
        overflow: 'hidden',
        height: '0px',
      })),
      transition('* => *', animate('200ms')),
    ])
  ]
})
export class MmExpansionComponent {
  @Input() expanded = false;
  @Input() arrowToggler = false;
  @Input() disableAnimation = false;
  @Input() togglerPosition: 'default' | 'left' = 'default';
  @Input() testTarget = '';
  @Input() disableToggle: boolean;

  @Output() toggled = new EventEmitter<boolean>();

  toggleExpand() {
    if (this.disableToggle) {
      return;
    }
    this.expanded = !this.expanded;

    this.toggled.emit(this.expanded);
  }
}
